import { formatDistance } from 'date-fns/formatDistance';

// eslint-disable-next-line @treasury/no-date
export const dateDistance = (date: Date, relativeDate: Date) =>
    formatDistance(date, relativeDate) as string;
